var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 2.66675C8.8935 8.73341 5.3335 13.9734 5.3335 18.4001C5.3335 25.0401 10.4002 29.3334 16.0002 29.3334C21.6002 29.3334 26.6668 25.0401 26.6668 18.4001C26.6668 13.9734 23.1068 8.73341 16.0002 2.66675ZM10.4402 18.6667C10.9335 18.6667 11.3335 19.0134 11.4268 19.4934C11.9735 22.4534 14.4668 23.4667 16.2802 23.3201C16.8535 23.2934 17.3335 23.7467 17.3335 24.3201C17.3335 24.8534 16.9068 25.2934 16.3735 25.3201C13.5335 25.4934 10.2135 23.8667 9.4535 19.8267C9.43033 19.6838 9.43848 19.5375 9.4774 19.398C9.51631 19.2585 9.58506 19.1292 9.67889 19.0188C9.77272 18.9085 9.88939 18.8199 10.0208 18.7591C10.1523 18.6983 10.2953 18.6668 10.4402 18.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterDrop);
export default __webpack_public_path__ + "static/media/water-drop.a2bec120c4f62cba594c86e0b34adcc5.svg";
export { ForwardRef as ReactComponent };